export enum ReportGenerationStatusTypeEnum {
  IN_PROGRESS = 'IN_PROGRESS',
  SUCCESSFUL = 'SUCCESSFUL',
  FAILED = 'FAILED',
  NO_DATA = 'NO_DATA',
}
